import { types } from './actions';

const initialState = {
  isSupplierTaxRateSaving: false,
};

const reducer = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case types.UPDATE_SUPPLIER_TAX_RATE_ERROR:
      return {
        ...state,
        isSupplierTaxRateSaving: false,
      };
    case types.UPDATE_SUPPLIER_TAX_RATE_REQUEST:
      return {
        ...state,
        isSupplierTaxRateSaving: true,
      };
    case types.UPDATE_SUPPLIER_TAX_RATE_SUCCESS:
      return {
        ...state,
        isSupplierTaxRateSaving: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.accounting.defaultTaxRate;

export const isSupplierTaxRateSaving = (state) =>
  getScope(state).isSupplierTaxRateSaving;
